function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.625 4.5H9.375C8.61561 4.5 8 5.11561 8 5.875V19.125C8 19.8844 8.61561 20.5 9.375 20.5H16.625C17.3844 20.5 18 19.8844 18 19.125V5.875C18 5.11561 17.3844 4.5 16.625 4.5Z",
  stroke: "#899296",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 5.5H14",
  stroke: "#899296",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 17.5V17.51",
  stroke: "#899296",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9032 0.5H4.09677C2.38647 0.5 1 1.8674 1 3.55417V21.4458C1 23.1326 2.38647 24.5 4.09677 24.5H21.9032C23.6135 24.5 25 23.1326 25 21.4458V3.55417C25 1.8674 23.6135 0.5 21.9032 0.5Z",
  stroke: "#899296"
});

var SvgIconButtonPhoneBorder = function SvgIconButtonPhoneBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconButtonPhoneBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_button_phone_border.e6fa324c.svg";
export { ForwardRef as ReactComponent };